// import React, { useState, useEffect } from "react";
// import { useParams, useHistory } from "react-router-dom";
// import { styled } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import { getDatabase, ref, push, set, get, remove, onValue } from "firebase/database";
// import { app, database } from "../../Firebase/firebase.config";
// import SideNav from "../SideNav";
// import { toast, Toaster } from "react-hot-toast";

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const INDUSTRIES = ["Doctor", "Dentist", "Physiotherapy", "Nurse", "Paramedical", "Ayurveda"];
// const JOB_TYPES = ["Full-Time", "Part-Time", "Contract", "Internship"];

// const EMPTY_FORM = {
//   title: "",
//   industry: "Doctor",
//   specialty: "",
//   type: "Full-Time",
//   experience: "",
//   salaryMin: "",
//   salaryMax: "",
//   location: "",
//   description: "",
//   requirements: "",
//   skills: "",
//   deadline: "",
//   featured: false,
//   urgent: false,
// };

// const styles = `
//   @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&family=Poppins:wght@500;600;700&display=swap');

//   .pj-page { font-family:'Nunito',sans-serif; color:#1a3a4a; }

//   .pj-wrapper {
//     max-width: 860px;
//     margin: 0 auto;
//     padding: 24px 28px 60px;
//   }

//   .pj-header { margin-bottom: 28px; }
//   .pj-header h1 {
//     font-family:'Poppins',sans-serif;
//     font-size:1.7rem; font-weight:700;
//     color:#0d4a55; margin-bottom:4px;
//   }
//   .pj-header p { color:#5a8a94; font-size:0.95rem; }
//   .pj-header-line {
//     height:3px; width:56px; border-radius:2px;
//     background:linear-gradient(90deg,#0d7377,#14a085);
//     margin-top:10px;
//   }

//   .pj-section {
//     background:#fff;
//     border:1.5px solid #d5eef0;
//     border-radius:18px;
//     padding:24px;
//     margin-bottom:20px;
//     box-shadow:0 2px 12px rgba(13,115,119,0.04);
//   }
//   .pj-section-header {
//     display:flex; align-items:center; gap:10px;
//     margin-bottom:20px;
//   }
//   .pj-section-header h3 {
//     font-family:'Poppins',sans-serif;
//     font-size:1rem; font-weight:600; color:#0d4a55; margin:0;
//   }
//   .pj-section-icon {
//     width:36px; height:36px; border-radius:10px;
//     background:linear-gradient(135deg,#e0f7f3,#c8eee8);
//     display:flex; align-items:center; justify-content:center;
//     font-size:1.1rem; flex-shrink:0;
//     border:1px solid #b8e4e0;
//   }

//   .pj-grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
//   .pj-grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
//   .pj-form-group { display:flex; flex-direction:column; gap:5px; }
//   .pj-label { font-size:0.8rem; font-weight:700; color:#4a7a82; text-transform:uppercase; letter-spacing:0.07em; }
//   .pj-input {
//     padding:10px 13px; border:1.5px solid #c5e5e8;
//     border-radius:10px; font-family:'Nunito',sans-serif;
//     font-size:0.92rem; color:#1a3a4a; background:#f5fcfd;
//     outline:none; transition:border-color 0.2s;
//     width:100%; box-sizing:border-box;
//   }
//   .pj-input:focus { border-color:#0d7377; background:#fff; }
//   .pj-textarea { resize:vertical; min-height:100px; }

//   .pj-select {
//     padding:10px 13px; border:1.5px solid #c5e5e8;
//     border-radius:10px; font-family:'Nunito',sans-serif;
//     font-size:0.92rem; color:#1a3a4a; background:#f5fcfd;
//     outline:none; cursor:pointer; transition:border-color 0.2s;
//     width:100%; box-sizing:border-box;
//   }
//   .pj-select:focus { border-color:#0d7377; }

//   .pj-salary-row { display:grid; grid-template-columns:1fr auto 1fr; gap:10px; align-items:end; }
//   .pj-salary-sep { text-align:center; color:#8aacb2; font-weight:700; padding-bottom:11px; }

//   .pj-toggle-row { display:flex; gap:24px; margin-top:4px; }
//   .pj-toggle-item {
//     display:flex; align-items:center; gap:8px;
//     cursor:pointer; font-size:0.9rem; font-weight:600; color:#2a5a64;
//   }
//   .pj-toggle-item input[type=checkbox] { width:16px; height:16px; accent-color:#0d7377; cursor:pointer; }

//   .pj-hint { font-size:0.78rem; color:#8aacb2; margin-top:3px; }

//   /* Buttons */
//   .pj-btn {
//     padding:11px 24px; border-radius:11px; font-family:'Nunito',sans-serif;
//     font-weight:700; font-size:0.9rem; cursor:pointer; border:none; transition:all 0.2s;
//   }
//   .pj-btn-primary {
//     background:linear-gradient(135deg,#0d7377,#14a085); color:#fff;
//     box-shadow:0 4px 14px rgba(13,115,119,0.28);
//   }
//   .pj-btn-primary:hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(13,115,119,0.38); }
//   .pj-btn-primary:disabled { opacity:0.6; cursor:not-allowed; transform:none; }
//   .pj-btn-outline {
//     background:transparent; color:#0d7377;
//     border:1.5px solid #0d7377;
//   }
//   .pj-btn-outline:hover { background:#e0f7f3; }
//   .pj-btn-danger {
//     background:#fff0ee; color:#c04030;
//     border:1.5px solid #f5c0b8;
//   }
//   .pj-btn-danger:hover { background:#ffe0dc; }

//   .pj-form-footer { display:flex; gap:12px; margin-top:8px; flex-wrap:wrap; }

//   /* Posted jobs list */
//   .pj-jobs-list { display:flex; flex-direction:column; gap:14px; margin-top:8px; }
//   .pj-job-card {
//     background:#f5fcfd; border:1.5px solid #c8e8ec;
//     border-radius:14px; padding:18px 20px;
//     display:flex; justify-content:space-between; align-items:flex-start; gap:12px;
//   }
//   .pj-job-card-left { flex:1; }
//   .pj-job-card-title { font-family:'Poppins',sans-serif; font-weight:600; color:#0d4a55; font-size:1rem; margin-bottom:3px; }
//   .pj-job-card-meta { font-size:0.85rem; color:#5a8a94; display:flex; flex-wrap:wrap; gap:10px; margin-top:4px; }
//   .pj-job-card-meta span { display:flex; align-items:center; gap:4px; }
//   .pj-job-card-actions { display:flex; gap:8px; flex-shrink:0; }
//   .pj-job-badge {
//     display:inline-block; padding:2px 10px; border-radius:20px;
//     font-size:0.72rem; font-weight:800; margin-left:6px;
//   }
//   .pj-badge-featured { background:#e0f7f0; color:#0d7377; border:1px solid #b0e8da; }
//   .pj-badge-urgent   { background:#fff0e8; color:#d4631a; border:1px solid #fad0b0; }

//   .pj-empty {
//     text-align:center; padding:40px 20px;
//     color:#8aacb2; font-size:0.95rem;
//   }
//   .pj-empty-icon { font-size:2.5rem; margin-bottom:10px; }

//   @media(max-width:700px) {
//     .pj-grid-2,.pj-grid-3 { grid-template-columns:1fr; }
//     .pj-salary-row { grid-template-columns:1fr 1fr; }
//     .pj-salary-sep { display:none; }
//     .pj-wrapper { padding:16px 12px 48px; }
//   }
// `;

// const Field = ({ label, hint, children }) => (
//   <div className="pj-form-group">
//     <label className="pj-label">{label}</label>
//     {children}
//     {hint && <span className="pj-hint">{hint}</span>}
//   </div>
// );

// export default function PostJob() {
//   const { id } = useParams();
//   const history = useHistory();

//   const [form, setForm] = useState(EMPTY_FORM);
//   const [loading, setLoading] = useState(false);
//   const [editingKey, setEditingKey] = useState(null);
//   const [postedJobs, setPostedJobs] = useState([]);
//   const [doctorInfo, setDoctorInfo] = useState({});

//   // Load doctor info and listen for this doctor's jobs
//   useEffect(() => {
//     if (!id) return;
//     const db = getDatabase(app);

//     get(ref(db, `doctor/${id}`)).then((snap) => {
//       if (snap.exists()) setDoctorInfo(snap.val());
//     });

//     const unsub = onValue(ref(database, `jobs/${id}`), (snap) => {
//       if (snap.exists()) {
//         const data = snap.val();
//         const list = Object.entries(data).map(([key, val]) => ({ key, ...val }));
//         setPostedJobs(list.reverse());
//       } else {
//         setPostedJobs([]);
//       }
//     });

//     return () => unsub();
//   }, [id]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.title || !form.specialty || !form.location) {
//       toast.error("Please fill in all required fields");
//       return;
//     }
//     setLoading(true);
//     try {
//       const db = getDatabase(app);
//       const fullName = [doctorInfo.First, doctorInfo.Middle, doctorInfo.Last].filter(Boolean).join(" ");

//       const jobData = {
//         ...form,
//         skills: form.skills.split(",").map((s) => s.trim()).filter(Boolean),
//         requirements: form.requirements.split("\n").map((r) => r.trim()).filter(Boolean),
//         salary: form.salaryMin && form.salaryMax
//           ? `₹${form.salaryMin} - ₹${form.salaryMax}/month`
//           : form.salaryMin || "Not disclosed",
//         company: doctorInfo.ClinicName || fullName || "Doctor's Clinic",
//         location: `${form.location}${doctorInfo.City ? ", " + doctorInfo.City : ""}`,
//         logo: "🏥",
//         posted: new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }),
//         postedAt: new Date().toISOString(),
//         doctorId: id,
//       };

//       if (editingKey) {
//         await set(ref(db, `jobs/${id}/${editingKey}`), jobData);
//         toast.success("Job updated successfully!");
//         setEditingKey(null);
//       } else {
//         const newRef = push(ref(db, `jobs/${id}`));
//         await set(newRef, { ...jobData, id: newRef.key });
//         toast.success("Job posted successfully!");
//       }

//       setForm(EMPTY_FORM);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to save job");
//     }
//     setLoading(false);
//   };

//   const handleEdit = (job) => {
//     const { key, skills, requirements, salary, company, location, postedAt, posted, doctorId, logo, id: _id, ...rest } = job;
//     setForm({
//       ...EMPTY_FORM,
//       ...rest,
//       skills: Array.isArray(skills) ? skills.join(", ") : skills || "",
//       requirements: Array.isArray(requirements) ? requirements.join("\n") : requirements || "",
//       salaryMin: "",
//       salaryMax: "",
//       location: rest.location ? rest.location.split(",")[0].trim() : "",
//     });
//     setEditingKey(key);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleDelete = async (jobKey) => {
//     if (!window.confirm("Delete this job posting?")) return;
//     try {
//       const db = getDatabase(app);
//       await remove(ref(db, `jobs/${id}/${jobKey}`));
//       toast.success("Job removed");
//     } catch {
//       toast.error("Delete failed");
//     }
//   };

//   const handleCancel = () => {
//     setForm(EMPTY_FORM);
//     setEditingKey(null);
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <style>{styles}</style>
//       <SideNav id={id} />

//       <Box component="main" className="pj-page" sx={{ flexGrow: 1, minWidth: 0, py: 2, px: 0 }}>
//         <DrawerHeader />
//         <Toaster toastOptions={{ duration: 4000 }} />

//         <div className="pj-wrapper">
//           <div className="pj-header">
//             <h1>{editingKey ? "✏️ Edit Job Posting" : "📋 Post a Job"}</h1>
//             <p>
//               {editingKey
//                 ? "Update your job listing details below"
//                 : "Fill in the details below to post a job opening at your clinic"}
//             </p>
//             <div className="pj-header-line" />
//           </div>

//           <form onSubmit={handleSubmit}>
//             {/* Basic Info */}
//             <div className="pj-section">
//               <div className="pj-section-header">
//                 <div className="pj-section-icon">💼</div>
//                 <h3>Job Details</h3>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
//                 <Field label="Job Title *">
//                   <input className="pj-input" name="title" value={form.title} onChange={handleChange} placeholder="e.g. Senior Cardiologist, Staff Nurse – ICU" required />
//                 </Field>
//                 <div className="pj-grid-3">
//                   <Field label="Industry *">
//                     <select className="pj-select" name="industry" value={form.industry} onChange={handleChange}>
//                       {INDUSTRIES.map((i) => <option key={i}>{i}</option>)}
//                     </select>
//                   </Field>
//                   <Field label="Specialty *">
//                     <input className="pj-input" name="specialty" value={form.specialty} onChange={handleChange} placeholder="e.g. Cardiology, ICU" required />
//                   </Field>
//                   <Field label="Job Type">
//                     <select className="pj-select" name="type" value={form.type} onChange={handleChange}>
//                       {JOB_TYPES.map((t) => <option key={t}>{t}</option>)}
//                     </select>
//                   </Field>
//                 </div>
//                 <div className="pj-grid-2">
//                   <Field label="Experience Required">
//                     <input className="pj-input" name="experience" value={form.experience} onChange={handleChange} placeholder="e.g. 3-5 Years, Fresher OK" />
//                   </Field>
//                   <Field label="Location *">
//                     <input className="pj-input" name="location" value={form.location} onChange={handleChange} placeholder="e.g. Andheri West, Mumbai" required />
//                   </Field>
//                 </div>
//                 <Field label="Salary Range (per month)">
//                   <div className="pj-salary-row">
//                     <input className="pj-input" name="salaryMin" value={form.salaryMin} onChange={handleChange} placeholder="Min (e.g. ₹50,000)" />
//                     <div className="pj-salary-sep">–</div>
//                     <input className="pj-input" name="salaryMax" value={form.salaryMax} onChange={handleChange} placeholder="Max (e.g. ₹1,20,000)" />
//                   </div>
//                 </Field>
//                 <Field label="Application Deadline">
//                   <input className="pj-input" type="date" name="deadline" value={form.deadline} onChange={handleChange} />
//                 </Field>
//               </div>
//             </div>

//             {/* Description */}
//             <div className="pj-section">
//               <div className="pj-section-header">
//                 <div className="pj-section-icon">📝</div>
//                 <h3>Job Description & Requirements</h3>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
//                 <Field label="Job Description *">
//                   <textarea className="pj-input pj-textarea" name="description" value={form.description} onChange={handleChange} placeholder="Describe the role, responsibilities, and what the candidate will be doing…" rows={4} required />
//                 </Field>
//                 <Field label="Requirements" hint="Enter each requirement on a new line">
//                   <textarea className="pj-input pj-textarea" name="requirements" value={form.requirements} onChange={handleChange} placeholder={"MBBS + MD Cardiology\n5+ years post-PG experience\nBLS/ACLS certification"} rows={4} />
//                 </Field>
//                 <Field label="Key Skills" hint="Comma-separated — e.g. ECG Interpretation, Angioplasty, Echocardiography">
//                   <input className="pj-input" name="skills" value={form.skills} onChange={handleChange} placeholder="ECG Interpretation, Angioplasty, Patient Management" />
//                 </Field>
//               </div>
//             </div>

//             {/* Flags */}
//             <div className="pj-section">
//               <div className="pj-section-header">
//                 <div className="pj-section-icon">⭐</div>
//                 <h3>Listing Flags</h3>
//               </div>
//               <div className="pj-toggle-row">
//                 <label className="pj-toggle-item">
//                   <input type="checkbox" name="featured" checked={form.featured} onChange={handleChange} />
//                   ⭐ Mark as Featured
//                 </label>
//                 <label className="pj-toggle-item">
//                   <input type="checkbox" name="urgent" checked={form.urgent} onChange={handleChange} />
//                   🔴 Mark as Urgent Hiring
//                 </label>
//               </div>
//             </div>

//             <div className="pj-form-footer">
//               <button type="submit" className="pj-btn pj-btn-primary" disabled={loading}>
//                 {loading ? "Saving…" : editingKey ? "💾 Update Job" : "📤 Post Job Now"}
//               </button>
//               {editingKey && (
//                 <button type="button" className="pj-btn pj-btn-outline" onClick={handleCancel}>
//                   Cancel
//                 </button>
//               )}
//             </div>
//           </form>

//           {/* My Posted Jobs */}
//           <div className="pj-section" style={{ marginTop: "32px" }}>
//             <div className="pj-section-header">
//               <div className="pj-section-icon">📋</div>
//               <h3>My Posted Jobs ({postedJobs.length})</h3>
//             </div>

//             {postedJobs.length === 0 ? (
//               <div className="pj-empty">
//                 <div className="pj-empty-icon">📭</div>
//                 <p>No jobs posted yet. Fill in the form above to post your first job!</p>
//               </div>
//             ) : (
//               <div className="pj-jobs-list">
//                 {postedJobs.map((job) => (
//                   <div key={job.key} className="pj-job-card">
//                     <div className="pj-job-card-left">
//                       <div className="pj-job-card-title">
//                         {job.title}
//                         {job.featured && <span className="pj-job-badge pj-badge-featured">⭐ Featured</span>}
//                         {job.urgent && <span className="pj-job-badge pj-badge-urgent">🔴 Urgent</span>}
//                       </div>
//                       <div className="pj-job-card-meta">
//                         <span>🏷 {job.specialty}</span>
//                         <span>💼 {job.type}</span>
//                         <span>📍 {job.location}</span>
//                         <span>💰 {job.salary}</span>
//                         <span>📅 Posted {job.posted}</span>
//                       </div>
//                     </div>
//                     <div className="pj-job-card-actions">
//                       <button className="pj-btn pj-btn-outline" style={{ padding: "8px 14px", fontSize: "0.83rem" }} onClick={() => handleEdit(job)}>
//                         ✏️ Edit
//                       </button>
//                       <button className="pj-btn pj-btn-danger" style={{ padding: "8px 14px", fontSize: "0.83rem" }} onClick={() => handleDelete(job.key)}>
//                         🗑 Delete
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </Box>
//     </Box>
//   );
// }


import React, { useState, useEffect } from "react";
import AutosuggestInput from "./AutosuggestInput";
import { useParams, useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { getDatabase, ref, push, set, get, remove, onValue } from "firebase/database";
import { app, database } from "../../Firebase/firebase.config";
import SideNav from "../SideNav";
import { toast, Toaster } from "react-hot-toast";
 
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
 
const INDUSTRIES = ["Doctor", "Dentist", "Physiotherapy", "Nurse", "Paramedical", "Ayurveda"];
const JOB_TYPES = ["Full-Time", "Part-Time", "Contract", "Internship"];
 
const EXPERIENCE_OPTIONS = [
  "Fresher (0 Years)",
  "0 - 1 Years",
  "1 - 2 Years",
  "2 - 3 Years",
  "3 - 5 Years",
  "5 - 7 Years",
  "7 - 10 Years",
  "More than 10 Years",
  "More than 15 Years",
];
 
const SALARY_RANGES = [
  "₹0 - ₹10,000",
  "₹10,000 - ₹15,000",
  "₹15,000 - ₹20,000",
  "₹20,000 - ₹25,000",
  "₹25,000 - ₹30,000",
  "₹30,000 - ₹40,000",
  "₹40,000 - ₹50,000",
  "₹50,000 - ₹60,000",
  "₹60,000 - ₹75,000",
  "₹75,000 - ₹1,00,000",
  "₹1,00,000 - ₹1,50,000",
  "₹1,50,000 - ₹2,00,000",
  "₹2,00,000 - ₹3,00,000",
  "More than ₹3,00,000",
];
 
const EMPTY_FORM = {
  title: "",
  industry: "Doctor",
  type: "Full-Time",
  experience: "",
  salary: "",
  location: "",
  description: "",
  requirements: "",
  skills: "",
  deadline: "",
  featured: false,
  urgent: false,
};
 
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&family=Poppins:wght@500;600;700&display=swap');
 
  .pj-page { font-family:'Nunito',sans-serif; color:#1a3a4a; }
 
  .pj-wrapper {
    max-width: 860px;
    margin: 0 auto;
    padding: 24px 28px 60px;
  }
 
  .pj-header { margin-bottom: 28px; }
  .pj-header h1 {
    font-family:'Poppins',sans-serif;
    font-size:1.7rem; font-weight:700;
    color:#0d4a55; margin-bottom:4px;
  }
  .pj-header p { color:#5a8a94; font-size:0.95rem; }
  .pj-header-line {
    height:3px; width:56px; border-radius:2px;
    background:linear-gradient(90deg,#0d7377,#14a085);
    margin-top:10px;
  }
 
  .pj-section {
    background:#fff;
    border:1.5px solid #d5eef0;
    border-radius:18px;
    padding:24px;
    margin-bottom:20px;
    box-shadow:0 2px 12px rgba(13,115,119,0.04);
  }
  .pj-section-header {
    display:flex; align-items:center; gap:10px;
    margin-bottom:20px;
  }
  .pj-section-header h3 {
    font-family:'Poppins',sans-serif;
    font-size:1rem; font-weight:600; color:#0d4a55; margin:0;
  }
  .pj-section-icon {
    width:36px; height:36px; border-radius:10px;
    background:linear-gradient(135deg,#e0f7f3,#c8eee8);
    display:flex; align-items:center; justify-content:center;
    font-size:1.1rem; flex-shrink:0;
    border:1px solid #b8e4e0;
  }
 
  .pj-grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
  .pj-grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
  .pj-form-group { display:flex; flex-direction:column; gap:5px; }
  .pj-label { font-size:0.8rem; font-weight:700; color:#4a7a82; text-transform:uppercase; letter-spacing:0.07em; }
  .pj-input {
    padding:10px 13px; border:1.5px solid #c5e5e8;
    border-radius:10px; font-family:'Nunito',sans-serif;
    font-size:0.92rem; color:#1a3a4a; background:#f5fcfd;
    outline:none; transition:border-color 0.2s;
    width:100%; box-sizing:border-box;
  }
  .pj-input:focus { border-color:#0d7377; background:#fff; }
  .pj-textarea { resize:vertical; min-height:100px; }
 
  .pj-select {
    padding:10px 13px; border:1.5px solid #c5e5e8;
    border-radius:10px; font-family:'Nunito',sans-serif;
    font-size:0.92rem; color:#1a3a4a; background:#f5fcfd;
    outline:none; cursor:pointer; transition:border-color 0.2s;
    width:100%; box-sizing:border-box;
  }
  .pj-select:focus { border-color:#0d7377; }
 
  .pj-salary-row { display:grid; grid-template-columns:1fr auto 1fr; gap:10px; align-items:end; }
  .pj-salary-sep { text-align:center; color:#8aacb2; font-weight:700; padding-bottom:11px; }
 
  .pj-toggle-row { display:flex; gap:24px; margin-top:4px; }
  .pj-toggle-item {
    display:flex; align-items:center; gap:8px;
    cursor:pointer; font-size:0.9rem; font-weight:600; color:#2a5a64;
  }
  .pj-toggle-item input[type=checkbox] { width:16px; height:16px; accent-color:#0d7377; cursor:pointer; }
 
  .pj-hint { font-size:0.78rem; color:#8aacb2; margin-top:3px; }
 
  /* Buttons */
  .pj-btn {
    padding:11px 24px; border-radius:11px; font-family:'Nunito',sans-serif;
    font-weight:700; font-size:0.9rem; cursor:pointer; border:none; transition:all 0.2s;
  }
  .pj-btn-primary {
    background:linear-gradient(135deg,#0d7377,#14a085); color:#fff;
    box-shadow:0 4px 14px rgba(13,115,119,0.28);
  }
  .pj-btn-primary:hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(13,115,119,0.38); }
  .pj-btn-primary:disabled { opacity:0.6; cursor:not-allowed; transform:none; }
  .pj-btn-outline {
    background:transparent; color:#0d7377;
    border:1.5px solid #0d7377;
  }
  .pj-btn-outline:hover { background:#e0f7f3; }
  .pj-btn-danger {
    background:#fff0ee; color:#c04030;
    border:1.5px solid #f5c0b8;
  }
  .pj-btn-danger:hover { background:#ffe0dc; }
 
  .pj-form-footer { display:flex; gap:12px; margin-top:8px; flex-wrap:wrap; }
 
  /* Posted jobs list */
  .pj-jobs-list { display:flex; flex-direction:column; gap:14px; margin-top:8px; }
  .pj-job-card {
    background:#f5fcfd; border:1.5px solid #c8e8ec;
    border-radius:14px; padding:18px 20px;
    display:flex; justify-content:space-between; align-items:flex-start; gap:12px;
  }
  .pj-job-card-left { flex:1; }
  .pj-job-card-title { font-family:'Poppins',sans-serif; font-weight:600; color:#0d4a55; font-size:1rem; margin-bottom:3px; }
  .pj-job-card-meta { font-size:0.85rem; color:#5a8a94; display:flex; flex-wrap:wrap; gap:10px; margin-top:4px; }
  .pj-job-card-meta span { display:flex; align-items:center; gap:4px; }
  .pj-job-card-actions { display:flex; gap:8px; flex-shrink:0; }
  .pj-job-badge {
    display:inline-block; padding:2px 10px; border-radius:20px;
    font-size:0.72rem; font-weight:800; margin-left:6px;
  }
  .pj-badge-featured { background:#e0f7f0; color:#0d7377; border:1px solid #b0e8da; }
  .pj-badge-urgent   { background:#fff0e8; color:#d4631a; border:1px solid #fad0b0; }
 
  .pj-empty {
    text-align:center; padding:40px 20px;
    color:#8aacb2; font-size:0.95rem;
  }
  .pj-empty-icon { font-size:2.5rem; margin-bottom:10px; }
 
  /* Salary autosuggest dropdown */
  .pj-salary-wrap { position:relative; width:100%; }
  .pj-salary-dropdown {
    position:absolute; top:calc(100% + 4px); left:0; right:0;
    background:#fff; border:1.5px solid #0d7377; border-radius:12px;
    box-shadow:0 8px 24px rgba(13,115,119,0.16); z-index:999;
    max-height:220px; overflow-y:auto;
  }
  .pj-salary-item {
    padding:9px 14px; font-size:0.88rem; font-weight:600;
    color:#1a3a4a; cursor:pointer; border-bottom:1px solid #f0f8f9;
    font-family:'Nunito',sans-serif; transition:background 0.15s;
  }
  .pj-salary-item:last-child { border-bottom:none; }
  .pj-salary-item:hover,.pj-salary-item.active { background:#e0f7f3; color:#0d7377; }
 
 
 
  @media(max-width:700px) {
    .pj-grid-2,.pj-grid-3 { grid-template-columns:1fr; }
    .pj-salary-row { grid-template-columns:1fr 1fr; }
    .pj-salary-sep { display:none; }
    .pj-wrapper { padding:16px 12px 48px; }
  }
`;
 
const Field = ({ label, hint, children }) => (
  <div className="pj-form-group">
    <label className="pj-label">{label}</label>
    {children}
    {hint && <span className="pj-hint">{hint}</span>}
  </div>
);
 
/* ── Salary Autosuggest ── */
const SalaryAutosuggest = ({ value, onChange }) => {
  const [open, setOpen] = React.useState(false);
  const [filtered, setFiltered] = React.useState(SALARY_RANGES);
  const wrapRef = React.useRef(null);
 
  React.useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
 
  const handleInput = (e) => {
    const val = e.target.value;
    onChange(val);
    const q = val.toLowerCase().replace(/[₹,]/g, "");
    setFiltered(
      q ? SALARY_RANGES.filter((r) => r.toLowerCase().replace(/[₹,]/g, "").includes(q)) : SALARY_RANGES
    );
    setOpen(true);
  };
 
  return (
    <div className="pj-salary-wrap" ref={wrapRef}>
      <input
        className="pj-input"
        type="text"
        value={value}
        onChange={handleInput}
        onFocus={() => { setFiltered(SALARY_RANGES); setOpen(true); }}
        placeholder="e.g. ₹30,000 - ₹40,000 or type to filter…"
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div className="pj-salary-dropdown">
          {filtered.map((r) => (
            <div
              key={r}
              className="pj-salary-item"
              onMouseDown={() => { onChange(r); setOpen(false); }}
            >
              💰 {r}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
 
 
 
export default function PostJob() {
  const { id } = useParams();
  const history = useHistory();
 
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [postedJobs, setPostedJobs] = useState([]);
  const [doctorInfo, setDoctorInfo] = useState({});
 
  // Load doctor info and listen for this doctor's jobs
  useEffect(() => {
    if (!id) return;
    const db = getDatabase(app);
 
    get(ref(db, `doctor/${id}`)).then((snap) => {
      if (snap.exists()) setDoctorInfo(snap.val());
    });
 
    const unsub = onValue(ref(database, `jobs/${id}`), (snap) => {
      if (snap.exists()) {
        const data = snap.val();
        const list = Object.entries(data).map(([key, val]) => ({ key, ...val }));
        setPostedJobs(list.reverse());
      } else {
        setPostedJobs([]);
      }
    });
 
    return () => unsub();
  }, [id]);
 
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.location) {
      toast.error("Please fill in all required fields");
      return;
    }
    setLoading(true);
    try {
      const db = getDatabase(app);
      const fullName = [doctorInfo.First, doctorInfo.Middle, doctorInfo.Last].filter(Boolean).join(" ");
 
      const jobData = {
        ...form,
        skills: form.skills.split(",").map((s) => s.trim()).filter(Boolean),
        requirements: form.requirements.split("\n").map((r) => r.trim()).filter(Boolean),
        salary: form.salary || "Not disclosed",
        company: doctorInfo.ClinicName || fullName || "Doctor's Clinic",
        location: `${form.location}${doctorInfo.City ? ", " + doctorInfo.City : ""}`,
        logo: "🏥",
        posted: new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }),
        postedAt: new Date().toISOString(),
        doctorId: id,
      };
 
      if (editingKey) {
        await set(ref(db, `jobs/${id}/${editingKey}`), jobData);
        toast.success("Job updated successfully!");
        setEditingKey(null);
      } else {
        const newRef = push(ref(db, `jobs/${id}`));
        await set(newRef, { ...jobData, id: newRef.key });
        toast.success("Job posted successfully!");
      }
 
      setForm(EMPTY_FORM);
    } catch (err) {
      console.error(err);
      toast.error("Failed to save job");
    }
    setLoading(false);
  };
 
  const handleEdit = (job) => {
    const { key, skills, requirements, salary, company, location, postedAt, posted, doctorId, logo, id: _id, ...rest } = job;
    setForm({
      ...EMPTY_FORM,
      ...rest,
      skills: Array.isArray(skills) ? skills.join(", ") : skills || "",
      requirements: Array.isArray(requirements) ? requirements.join("\n") : requirements || "",
      salary: rest.salary || "",
      location: rest.location ? rest.location.split(",")[0].trim() : "",
    });
    setEditingKey(key);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
 
  const handleDelete = async (jobKey) => {
    if (!window.confirm("Delete this job posting?")) return;
    try {
      const db = getDatabase(app);
      await remove(ref(db, `jobs/${id}/${jobKey}`));
      toast.success("Job removed");
    } catch {
      toast.error("Delete failed");
    }
  };
 
  const handleCancel = () => {
    setForm(EMPTY_FORM);
    setEditingKey(null);
  };
 
  return (
    <Box sx={{ display: "flex" }}>
      <style>{styles}</style>
      <SideNav id={id} />
 
      <Box component="main" className="pj-page" sx={{ flexGrow: 1, minWidth: 0, py: 2, px: 0 }}>
        <DrawerHeader />
        <Toaster toastOptions={{ duration: 4000 }} />
 
        <div className="pj-wrapper">
          <div className="pj-header">
            <h1>{editingKey ? "✏️ Edit Job Posting" : "📋 Post a Job"}</h1>
            <p>
              {editingKey
                ? "Update your job listing details below"
                : "Fill in the details below to post a job opening at your clinic"}
            </p>
            <div className="pj-header-line" />
          </div>
 
          <form onSubmit={handleSubmit}>
            {/* ── Job Details ── */}
            <div className="pj-section">
              <div className="pj-section-header">
                <div className="pj-section-icon">💼</div>
                <h3>Job Details</h3>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
 
                {/* Job Title with autosuggest */}
                <Field label="Job Title *">
                  <AutosuggestInput
                    name="title"
                    value={form.title}
                    onChange={(val) => setForm((p) => ({ ...p, title: val }))}
                    placeholder="e.g. Senior Cardiologist, Staff Nurse – ICU"
                    className="pj-input"
                    required
                  />
                </Field>
 
                {/* Industry + Job Type */}
                <div className="pj-grid-2">
                  <Field label="Industry *">
                    <select className="pj-select" name="industry" value={form.industry} onChange={handleChange}>
                      {INDUSTRIES.map((i) => <option key={i}>{i}</option>)}
                    </select>
                  </Field>
                  <Field label="Job Type">
                    <select className="pj-select" name="type" value={form.type} onChange={handleChange}>
                      {JOB_TYPES.map((t) => <option key={t}>{t}</option>)}
                    </select>
                  </Field>
                </div>
 
                {/* Experience dropdown + Location */}
                <div className="pj-grid-2">
                  <Field label="Experience Required">
                    <select className="pj-select" name="experience" value={form.experience} onChange={handleChange}>
                      <option value="">Select experience…</option>
                      {EXPERIENCE_OPTIONS.map((e) => <option key={e}>{e}</option>)}
                    </select>
                  </Field>
                  <Field label="Location *">
                    <input className="pj-input" name="location" value={form.location} onChange={handleChange} placeholder="e.g. Andheri West, Mumbai" required />
                  </Field>
                </div>
 
                {/* Salary Range autosuggest */}
                <Field label="Salary Range (per month)">
                  <SalaryAutosuggest
                    value={form.salary}
                    onChange={(val) => setForm((p) => ({ ...p, salary: val }))}
                  />
                </Field>
 
                {/* Deadline */}
                <Field label="Application Deadline">
                  <input className="pj-input" type="date" name="deadline" value={form.deadline} onChange={handleChange} />
                </Field>
              </div>
            </div>
 
            {/* ── Description & Requirements ── */}
            <div className="pj-section">
              <div className="pj-section-header">
                <div className="pj-section-icon">📝</div>
                <h3>Job Description & Requirements</h3>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
                <Field label="Job Description *">
                  <textarea className="pj-input pj-textarea" name="description" value={form.description} onChange={handleChange} placeholder="Describe the role, responsibilities, and what the candidate will be doing…" rows={4} required />
                </Field>
                <Field label="Requirements" hint="Enter each requirement on a new line">
                  <textarea className="pj-input pj-textarea" name="requirements" value={form.requirements} onChange={handleChange} placeholder={"MBBS + MD Cardiology\n5+ years post-PG experience\nBLS/ACLS certification"} rows={4} />
                </Field>
                <Field label="Key Skills" hint="Comma-separated — e.g. ECG Interpretation, Angioplasty, Echocardiography">
                  <input className="pj-input" name="skills" value={form.skills} onChange={handleChange} placeholder="ECG Interpretation, Angioplasty, Patient Management" />
                </Field>
              </div>
            </div>
 
 
            {/* ── Listing Flags ── */}
            <div className="pj-section">
              <div className="pj-section-header">
                <div className="pj-section-icon">⭐</div>
                <h3>Listing Flags</h3>
              </div>
              <div className="pj-toggle-row">
                <label className="pj-toggle-item">
                  <input type="checkbox" name="featured" checked={form.featured} onChange={handleChange} />
                  ⭐ Mark as Featured
                </label>
                <label className="pj-toggle-item">
                  <input type="checkbox" name="urgent" checked={form.urgent} onChange={handleChange} />
                  🔴 Mark as Urgent Hiring
                </label>
              </div>
            </div>
 
            <div className="pj-form-footer">
              <button type="submit" className="pj-btn pj-btn-primary" disabled={loading}>
                {loading ? "Saving…" : editingKey ? "💾 Update Job" : "📤 Post Job Now"}
              </button>
              {editingKey && (
                <button type="button" className="pj-btn pj-btn-outline" onClick={handleCancel}>
                  Cancel
                </button>
              )}
            </div>
          </form>
 
          {/* My Posted Jobs */}
          <div className="pj-section" style={{ marginTop: "32px" }}>
            <div className="pj-section-header">
              <div className="pj-section-icon">📋</div>
              <h3>My Posted Jobs ({postedJobs.length})</h3>
            </div>
 
            {postedJobs.length === 0 ? (
              <div className="pj-empty">
                <div className="pj-empty-icon">📭</div>
                <p>No jobs posted yet. Fill in the form above to post your first job!</p>
              </div>
            ) : (
              <div className="pj-jobs-list">
                {postedJobs.map((job) => (
                  <div key={job.key} className="pj-job-card">
                    <div className="pj-job-card-left">
                      <div className="pj-job-card-title">
                        {job.title}
                        {job.featured && <span className="pj-job-badge pj-badge-featured">⭐ Featured</span>}
                        {job.urgent && <span className="pj-job-badge pj-badge-urgent">🔴 Urgent</span>}
                      </div>
                      <div className="pj-job-card-meta">
                        <span>🏷 {job.specialty}</span>
                        <span>💼 {job.type}</span>
                        <span>📍 {job.location}</span>
                        <span>💰 {job.salary}</span>
                        <span>📅 Posted {job.posted}</span>
                      </div>
                    </div>
                    <div className="pj-job-card-actions">
                      <button className="pj-btn pj-btn-outline" style={{ padding: "8px 14px", fontSize: "0.83rem" }} onClick={() => handleEdit(job)}>
                        ✏️ Edit
                      </button>
                      <button className="pj-btn pj-btn-danger" style={{ padding: "8px 14px", fontSize: "0.83rem" }} onClick={() => handleDelete(job.key)}>
                        🗑 Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </Box>
    </Box>
  );
}